import axios from 'axios';
import buildPaginationQueryOpts from '@/shared/sort/sorts';
import { ITask } from '@/shared/model/resolution/task.model';
import { IMyBadgeCard } from '@/shared/model/dashboard/my-badge-card.model';
import { Vue } from 'vue-property-decorator';

const baseApiUrl = 'api/tasks';

export default class TaskService extends Vue {
  public find(id: number): Promise<ITask> {
    return new Promise<ITask>((resolve, reject) => {
      axios
        .get(`${baseApiUrl}/${id}`)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public findOneTaskCardInfoByTaskReceived(id: number): Promise<ITask> {
    return new Promise<ITask>((resolve, reject) => {
      axios
        .get(`${baseApiUrl}/card-info/by-task-received/${id}`)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public findOneTaskCardInfoById(id: number): Promise<ITask> {
    return new Promise<ITask>((resolve, reject) => {
      axios
        .get(`${baseApiUrl}/card-info/by-id/${id}`)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public findOneTaskInfoByIdAllStatus(id: number): Promise<ITask> {
    return new Promise<ITask>((resolve, reject) => {
      axios
        .get(`${baseApiUrl}/card-info/by-id/all-status/${id}`)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public retrieve(paginationQuery?: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(baseApiUrl + `?${buildPaginationQueryOpts(paginationQuery)}`)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public retrievePaging(paginationQuery: any, filter: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .post(baseApiUrl + `/paging?${buildPaginationQueryOpts(paginationQuery)}`, filter)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public delete(id: number): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .delete(`${baseApiUrl}/${id}`)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public deleteTaskForm(id: number): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .delete(`${baseApiUrl}/form/${id}`)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public create(entity: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .post(`${baseApiUrl}`, entity)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public createTaskWidthReceived(entity: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .post(`${baseApiUrl}/task-width-received`, entity)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public update(entity: ITask): Promise<ITask> {
    return new Promise<ITask>((resolve, reject) => {
      axios
        .put(`${baseApiUrl}`, entity)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public retrieveAllList(): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(baseApiUrl + `/all-list`)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }
  public getAllEqualExecutorsByTaskId(taskId: number): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(`${baseApiUrl}/get-all-executors-by-task-id/${taskId}`)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public findAllStatusList(): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(baseApiUrl + `/status/list`)
        .then(function (res) {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public findAllPriorityLevelList(): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(baseApiUrl + `/priority-level/list`)
        .then(function (res) {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public updateForm(entity: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .put(`${baseApiUrl}/update-form`, entity)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public retrieveControlTaskPaging(paginationQuery: any, filter: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .post(baseApiUrl + `/control-task/paging?${buildPaginationQueryOpts(paginationQuery)}`, filter)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public retrieveControlJusticeAppealPaging(paginationQuery: any, filter: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .post(baseApiUrl + `/control-justice-appeal/paging?${buildPaginationQueryOpts(paginationQuery)}`, filter)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }
  public retrieveControlJusticeAppealNotRegisteredPaging(paginationQuery: any, filter: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .post(baseApiUrl + `/control-justice-appeal/not-registered/paging?${buildPaginationQueryOpts(paginationQuery)}`, filter)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public retrieveControlJusticeAppealExcelExport(paginationQuery: any, filter: any) {
    return new Promise<any>((resolve, reject) => {
      axios
        .post(`${baseApiUrl}/branch-control/excel-export?${buildPaginationQueryOpts(paginationQuery)}`, filter, {
          responseType: 'blob',
        })
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public retrieveControlOnlineAppealPaging(paginationQuery: any, filter: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .post(baseApiUrl + `/control-online-appeal/paging?${buildPaginationQueryOpts(paginationQuery)}`, filter)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public retrieveControlAppealPaging(paginationQuery: any, filter: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .post(baseApiUrl + `/control-appeal-task/paging?${buildPaginationQueryOpts(paginationQuery)}`, filter)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public retrieveControlInternalTaskPaging(paginationQuery: any, filter: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .post(baseApiUrl + `/control-internal-task/paging?${buildPaginationQueryOpts(paginationQuery)}`, filter)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public getControlBadge(): Promise<IMyBadgeCard> {
    return new Promise<IMyBadgeCard>((resolve, reject) => {
      axios
        .get(`${baseApiUrl}/control/badge`)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public getControlIncomeTaskBadge(): Promise<IMyBadgeCard> {
    return new Promise<IMyBadgeCard>((resolve, reject) => {
      axios
        .get(`${baseApiUrl}/control-income-task/badge`)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public getControlInternalTaskBadge(): Promise<IMyBadgeCard> {
    return new Promise<IMyBadgeCard>((resolve, reject) => {
      axios
        .get(`${baseApiUrl}/control-internal-task/badge`)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public getControlAppealBadge(): Promise<IMyBadgeCard> {
    return new Promise<IMyBadgeCard>((resolve, reject) => {
      axios
        .get(`${baseApiUrl}/control-appeal-task/badge`)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public getControlJusticeAppealBadge(): Promise<IMyBadgeCard> {
    return new Promise<IMyBadgeCard>((resolve, reject) => {
      axios
        .get(`${baseApiUrl}/control-justice-appeal-task/badge`)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public getControlJusticeProblemBadge(): Promise<IMyBadgeCard> {
    return new Promise<IMyBadgeCard>((resolve, reject) => {
      axios
        .get(`${baseApiUrl}/control-justice-problem-task/badge`)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public getControlOnlineAppealBadge(): Promise<IMyBadgeCard> {
    return new Promise<IMyBadgeCard>((resolve, reject) => {
      axios
        .get(`${baseApiUrl}/control-online-appeal-task/badge`)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public downloadExcelProgress(filter: any) {
    return new Promise<any>((resolve, reject) => {
      axios
        .post(`api/download-excel-progress`, filter)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public retrieveDownloadExcelProgressPaging(paginationQuery: any, filter: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .post(`api/download-excel-progress/paging?${buildPaginationQueryOpts(paginationQuery)}`, filter)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public deleteDownloadExcelProgress(id: number): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .delete(`api/download-excel-progress/delete/${id}`)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public cancelDownloadExcelProgress(id: number): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .put(`api/download-excel-progress/cancel/${id}`)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public findAllControlTaskByJobExcelExport(paginationQuery: any, filter: any) {
    return new Promise<any>((resolve, reject) => {
      axios
        .post(`${baseApiUrl}/control-task/excel-export?${buildPaginationQueryOpts(paginationQuery)}`, filter, {
          responseType: 'blob',
        })
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public rejectToExecution(data: any) {
    return new Promise<any>((resolve, reject) => {
      axios
        .post(`${baseApiUrl}/reject-to-execution`, data)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  deleteDraftTaskReceivedById(taskReceivedId) {
    return new Promise<any>((resolve, reject) => {
      axios
        .delete(`${baseApiUrl}/delete-draft-task-received/${taskReceivedId}`)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }
}
